import { useState, useEffect } from "react";

function useMobile() {
  // State to track window width for responsive behavior
  const [isMobile, setIsMobile] = useState(false);

  // Check if we're on mobile device
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
    };

    // Initial check
    checkIfMobile();

    // Add event listener
    window.addEventListener("resize", checkIfMobile);

    // Cleanup
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  return isMobile;
}

export default useMobile;
